export enum deviceType {
    PC,
    Ios,
    Android,
    iPad,
}